import { gql } from '@apollo/client';

import { ISort, TClientsPaymentReportItem } from './types';

export interface IClientsReportRequest {
  input: {
    from: string;
    to: string;
    sorting?: ISort;
    search?: {
      q: string;
    };
  };
  page?: number;
  first?: number;
}
export interface IClientReportResponse {
  clientsPaymentReport: {
    paginatorInfo: {
      currentPage: number;
      lastPage: number;
    };
    data: Array<TClientsPaymentReportItem>;
  };
}
export const GENERATE_CLIENTS_REPORT = gql`
  query clientsPaymentReport(
    $input: ClientsPaymentReportInput!
    $first: Int
    $page: Int
  ) {
    clientsPaymentReport(input: $input, first: $first, page: $page) {
      paginatorInfo {
        currentPage
        lastPage
      }
      data {
        user {
          avatar_url
          nickname
          phone
          created_at
          deposit
          user_discount
          roles {
            alias
          }
          id
        }
        shop {
          value
        }
        tariff {
          value
        }
        total {
          value
        }
        average {
          value
        }
      }
    }
  }
`;
